<template>
  <div>
    <generic-title-bar :title="'Elenco titoli aperti'" />
    <div class="row-fluid">
      <div class="pull-left">
        <v-select2 v-if="!resetting" v-model="month" :options-list="monthOptions" @input="reloadSiad" :disabled="disableFields" />
        <v-select2 v-if="!resetting" v-model="year" :options-list="yearOptions" @input="reloadSiad" :disabled="disableFields" />
        <v-select2
          v-if="!resetting"
          v-model="period"
          :options-list="periodOptions"
          @input="resetAndDisableMonthYear"
          :data-placeholder="'Trimestre'"
        />
        <button name="button" type="button" class="js-tooltip btn btn-link" style="padding: 0" data-original-title="" title="">
          <i
            class="fa-solid fa-rotate pulsante_comando js-tooltip"
            title="Reset filtri temporali"
            data-original-title="Reset filtri"
            @click="resetFilters"
          ></i>
        </button>
        <v-select2
          v-model="guestIds"
          :data-placeholder="'Utenti'"
          :data-ajax--url="autocompleteGuestUrl"
          data-pageLimit="20"
          data-allow-clear="true"
          :multiple="true"
          @input="reloadSiad"
        ></v-select2>
      </div>
      <div class="buttons-wrapper">
        <span
          style=""
          class="fa-light fa-print pulsante_comando js-tooltip cursor-pointer"
          data-original-title="Stampa"
          @click="generateTitlesReport()"
        />
      </div>
    </div>

    <generic-table
      :headerLabels="headerLabels"
      :elements="getTableElements"
      :options="options"
      :lengthPage="lengthPage"
      @openUrlEvent="openUrl"
    />
  </div>
</template>

<script>
import apiConnector from '@/epersonam/apiConnector';
import { LabelApi } from '@/epersonam/mixins/labels.js';
import { Route } from '../../route';
import genericTable from '../genericTable/genericTable';
import genericTitleBar from '../genericTitleBar';
import VSelect2 from '../vSelect2.vue';

export default {
  name: 'openProfilesView',
  props: {
    show_monthly_prevision: { type: Boolean, required: false, default: false },
  },
  mixins: [LabelApi],
  components: {
    VSelect2,
    genericTable,
    genericTitleBar,
  },
  data() {
    return {
      resetting: false,
      activityConfigId: null,
      headerLabels: [
        i18nJS['guest_label'],
        i18nJS['nr_trattamento'],
        i18nJS['data_inizio'],
        i18nJS['durata_periodo'],
        i18nJS['data_fine_prevista'],
        i18nJS['giorni_rimanenti'],
        i18nJS['profilo_cura_previsto'],
        i18nJS['profilo_cura'],
        i18nJS['rimborso_previsto'],
        this.show_monthly_prevision ? i18nJS['montly_prevision'] : null,
        i18nJS['struttura'],
      ].filter((el) => el != null),
      tableElements: [],
      buId: window.config.business_unit.id,
      page: 0,
      lengthPage: 15,
      loading: true,
      month: moment().month() + 1,
      year: moment().year(),
      guestIds: [],
      autocompleteGuestUrl: `${Route.GUEST_BUSINESS_UNIT_AUTOCOMPLETE_GUESTS_FULL_NAME}?siad4=true`,
      disableFields: false,
      period: null,
      options: {
        actionColumnEnabled: true,
        canDeleteRow: false,
        canOpenUrl: true,
        infiniteScrollEnable: true,
        handleUpdate: this.handleUpdate,
      },
    };
  },
  computed: {
    getTableElements() {
      return this.tableElements.map(
        // [{name, qta, umd, ....}] -> [{name, qta, umd}]
        ({
          guest_name,
          anno_ricovero_numero_pratica,
          data_inizio_profilo_cura,
          durata,
          data_fine_prevista,
          periodo_rimanente,
          profilo_cura,
          calc_profilo_cura,
          price,
          price_estimation,
          struttura,
        }) => ({
          guest_name,
          anno_ricovero_numero_pratica,
          data_inizio_profilo_cura,
          durata,
          data_fine_prevista,
          periodo_rimanente,
          profilo_cura,
          calc_profilo_cura,
          price,
          ...(this.show_monthly_prevision && { price_estimation }),
          struttura,
        }),
      );
    },
    monthOptions() {
      return moment.months().map((m, i) => [m, i + 1]);
    },
    yearOptions() {
      let years = [];
      for (let i = 2016; i <= moment().year(); i++) {
        years.push([i, i]);
      }
      return years;
    },
    periodOptions() {
      const currentYear = new Date().getFullYear();
      const defaultYears = [currentYear - 1, currentYear];
      const periods = [1, 2, 3, 4];
      const options = [];
      defaultYears.forEach((y) => {
        periods.forEach((p) => {
          let startDate, endDate;
          switch (p) {
            case 1:
              startDate = moment(`${y}-01-01`).format('DD/MM/YYYY');
              endDate = moment(`${y}-03-31`).format('DD/MM/YYYY');
              break;
            case 2:
              startDate = moment(`${y}-04-01`).format('DD/MM/YYYY');
              endDate = moment(`${y}-06-30`).format('DD/MM/YYYY');
              break;
            case 3:
              startDate = moment(`${y}-07-01`).format('DD/MM/YYYY');
              endDate = moment(`${y}-09-30`).format('DD/MM/YYYY');
              break;
            case 4:
              startDate = moment(`${y}-10-01`).format('DD/MM/YYYY');
              endDate = moment(`${y}-12-31`).format('DD/MM/YYYY');
              break;
          }
          const textPeriod = `${p}° periodo: ${startDate} - ${endDate}`;
          options.push([textPeriod, `${y}0${p}`]);
        });
      });
      return options;
    },
  },
  methods: {
    reloadSiad() {
      this.page = 0;
      this.tableElements = [];
      return this.getSiad4sList();
    },
    handleUpdate(callback) {
      return this.getSiad4sList();
    },
    getSiad4sList() {
      this.adv_common.openAdvLoader();
      this.page += 1;
      return apiConnector()
        .get(`${Route.SIAD4}/profile_view.json`, {
          params: {
            business_unit_id: this.buId,
            per_page: this.lengthPage,
            month: this.month,
            year: this.year,
            period: this.period,
            guestIds: this.guestIds,
            page: this.page,
          },
        })
        .then(({ data }) => {
          try {
            this.tableElements = this.tableElements.concat(data);
            this.adv_common.closeAdvLoader();
            return data.length;
          } catch (err) {
            return 0;
          }
        })
        .catch((err) => {
          this.adv_common.closeAdvLoader();
          return 0;
        });
    },
    openUrl(item, index) {
      const s4 = this.tableElements[index];
      window.open(
        `${window.config.ePersonamService.ePersonamHost}/it/guest_period_data_sets/${s4.gpds_id}/siad1s/${s4.siad1_id}/edit`,
        '_blank',
      );
    },
    generateTitlesReport() {
      Loader.show();
      apiConnector()
        .post('/it/reports/generate_report', {
          type: 'csv',
          worker: 'CsvOpenProfilesSiads4Worker',
          month: this.month,
          year: this.year,
          period: this.period,
          guestIds: this.guestIds,
        })
        .then(() => {
          Loader.hide();
        })
        .catch((err) => {
          let msg = `${i18nJS['errors.critical_error']}: ${err.message} - ${err.response.data}`;
          if (err.response.status === 401) {
            msg = i18nJS['access_denied'];
          }
          Utils.appendToFlash('error', msg);
          Loader.hide();
        });
    },
    resetAndDisableMonthYear() {
      this.resetting = true;
      this.month = '';
      this.year = '';
      this.disableFields = true;

      this.$nextTick(() => {
        this.resetting = false; // Fine del reset
        this.reloadSiad(); // Ricarica i dati con i nuovi valori
      });
    },
    resetFilters() {
      this.resetting = true;

      this.disableFields = false;
      this.month = moment().month() + 1;
      this.year = moment().year();
      this.period = '';

      this.$nextTick(() => {
        this.resetting = false; // Fine del reset
        this.month = moment().month() + 1;
        this.year = moment().year();
        this.reloadSiad();
      });
    },
  },
  async mounted() {
    this.neededlabels = [
      'guest_label',
      'nr_trattamento',
      'durata_periodo',
      'data_fine_prevista',
      'giorni_rimanenti',
      'profilo_cura_previsto',
      'profilo_cura_calcolato',
      'rimborso_previsto',
      'errors.critical_error',
      'access_denied',
      'montly_prevision',
      'struttura',
    ];
    await this.setupLabels();
  },
};
</script>

<style lang="scss" scoped>
.buttons-wrapper {
  display: flex;
  justify-content: end;
}
</style>
